module.exports = __webpack_public_path__ + "img/seminar (47).b26842b4.jpg";